import { Component } from "@kluntje/core";
import { ACTIVE } from "Helper/cssClasses";
import { removeClass, addClass } from "@kluntje/js-utils/lib/dom-helpers";

class FRATab extends Component {
  constructor() {
    super({
      ui: {
        toggles: ".fra-js-tab__toggle",
        activeitem: ".fra-state-active",
        panels: ".fra-m-tab__panel",
        searchform: ".fra-m-flights-search__form :-one",
      },
      events: [
        {
          event: "click",
          target: "toggles",
          handler: "handleClick",
        },
      ],
      initialStates: {
        tab: "",
      },
    });
  }

  /**
   * Lifecycle hook
   */
  afterComponentRender(): void {
    this.setTabState();
  }

  /*
   * This function controls the tab behavior. When a user clicks on the toggles the tabs panels changes.
   */
  handleClick(e: Event): void {
    const target = e.target as HTMLButtonElement;
    const index = parseInt(target.dataset.tabTarget!, 10);

    this.resetTabs();
    this.setActiveTab(target, index);

    window.dataLayer?.push({
      event: "gaEvent",
      eventCategory: "FlightSearch",
      eventAction: "Tab switch",
      eventLabel: target.dataset.flightType ? target.dataset.flightType : "parking",
    });
    window.dispatchEvent(new CustomEvent("FRA_TAB_CHANGE", { detail: target.dataset.flightType }));
  }

  resetTabs() {
    this.ui.panels.forEach((tab: HTMLElement, index: number) => {
      removeClass(this.ui.toggles[index], ACTIVE);
      removeClass(tab, ACTIVE);
    });
    this.setState({ tab: "" });
  }

  setActiveTab(el: HTMLElement, index: number) {
    addClass(el, ACTIVE);
    addClass(this.ui.panels[index], ACTIVE);
    this.setState({ tab: `${index}` });
  }

  /**
   * fill in tab state, from the query params of the current page or the loaded html
   * URL param "flighttype=arrivals", "flighttype=departures"
   * paths to verify (examples)
   * /en/am-flughafen/ankuenfte.html, /en/am-flughafen/abfluge.html
   * https://author.dev.fraport.ad.diva-e.com/content/fraport-travel-sample/en/am-flughafen/ankuenfte.html
   */
  setTabState(): void {
    let flightType: string | null = null;
    // flight type search param is set if coming from startpage search
    const isSearchParamAvailable = new URL(document.location.href).searchParams.get("flighttype");

    if (isSearchParamAvailable) {
      flightType = new URL(document.location.href).searchParams.get("flighttype");
    } else {
      const arrivalsUrl = this.ui.searchform.getAttribute("data-overview-arrivals")?.split("?")[0] || undefined;
      const departuresUrl = this.ui.searchform.getAttribute("data-overview-departures")?.split("?")[0] || undefined;

      if (arrivalsUrl && document.location.href.includes(arrivalsUrl)) {
        flightType = "arrivals";
      } else if (departuresUrl && document.location.href.includes(departuresUrl)) {
        flightType = "departures";
      }
    }

    if (!flightType) {
      // When flighttype is not available, set the first tab and panel as active
      addClass(this.ui.toggles[0], ACTIVE);
      addClass(this.ui.panels[0], ACTIVE);
      return;
    }
    if (flightType === "departures") {
      addClass(this.ui.toggles[0], ACTIVE);
      addClass(this.ui.panels[0], ACTIVE);
    } else if (flightType === "arrivals") {
      addClass(this.ui.toggles[1], ACTIVE);
      addClass(this.ui.panels[1], ACTIVE);
    }
  }
}

customElements.define("fra-m-tab", FRATab);

export default FRATab;
